import { preparePhotos } from './preparePhotos';
import { IOfferCard } from '../../../../types';

export const prepareThumbnails = (offerCard: IOfferCard) => {
  const photos = preparePhotos(offerCard);

  if (!offerCard.showGalleryThumbnails || photos.length < 2) {
    return null;
  }

  return photos.slice(1, 4);
};
